<template>
  <div class="flex flex-col">
    <h2 class="font-medium text-lg text-gray-800 mb-1">{{ title }}</h2>
    <div class="flex items-center gap-3">
      <span class="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded-md">{{ category }}</span>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  category: {
    type: String,
    default: '',
  },
})
</script>